import React, { lazy, Suspense } from "react";
import { Loader } from "@sicredi/react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { PAGE } from "#/constants";
import { withOidcSecure } from "@axa-fr/react-oidc-context";

const LazyPlans = lazy(() => import("#/containers/Plans"));
const LazyNotFound = lazy(() => import("#/containers/NotFound"));
const LazyError = lazy(() => import("#/containers/Error"));
const LazySuccess = lazy(() => import("#/containers/Success"));
const LazyNotAuthenticated = lazy(
  () => import("#/containers/NotAuthenticated")
);
const MyPlanRoutes = lazy(() => import("./myPlanRoutes"));

export const Routes: React.FC = () => (
  <Router basename={process.env.PUBLIC_URL}>
    <Suspense fallback={<Loader show fullScreen />}>
      <Switch>
        <Route exact path={PAGE.ROOT()} component={withOidcSecure(LazyPlans)} />
        <Route path={PAGE.MY_PLAN.ROOT()} component={MyPlanRoutes} />

        <Route exact path={PAGE.ERROR()} component={LazyError} />
        <Route exact path={PAGE.SUCCESS()} component={LazySuccess} />
        <Route
          exact
          path={PAGE.NOT_AUTHENTICATED()}
          component={LazyNotAuthenticated}
        />
        <Route exact path={PAGE.NOT_FOUND()} component={LazyNotFound} />
        <Route path="*" component={LazyNotFound} />
      </Switch>
    </Suspense>
  </Router>
);
